class LocalStorageHelper {
  private storageAvailable: boolean;

  constructor() {
    this.storageAvailable = this.checkAvailability();
  }

  private checkAvailability(): boolean {
    if (typeof window === 'undefined') return false;

    try {
      const test = '__storage_test__';
      window.localStorage.setItem(test, test);
      window.localStorage.removeItem(test);
      return true;
    } catch {
      return false;
    }
  }

  getItem(key: string) {
    if (!this.storageAvailable) return null;
    return window.localStorage.getItem(key);
  }

  setItem(key: string, value: string) {
    if (!this.storageAvailable) return;
    window.localStorage.setItem(key, value);
  }

  removeItem(key: string) {
    if (!this.storageAvailable) return;
    window.localStorage.removeItem(key);
  }
}

export default new LocalStorageHelper();